import React from 'react'
import { Badge, Grid2, Card, CardContent, Box } from '@mui/material'
import PropTypes from 'prop-types'
import i18n from 'simple-react-i18n'
import { Close, NoteAddOutlined } from '@mui/icons-material'
import pdf from '../../assets/pictures/logos/pdf.svg'
import excel from '../../assets/pictures/logos/excel.svg'
import TaskIcon from '@mui/icons-material/Task'
import { LARGE_RADIUS } from 'utils/constants/Theme'
import { template } from 'lodash'


// files => il faut passer une liste même si le composant ne doit recevoir qu'un seul fichier.
// fileAccept => exemple : '.pdf, image/*, .xlsx, .xls, .docx, .odt, .csv, .zip'
const FileSelection = ({ files, setFiles, multiple=false, fileAccept='' }) => {
    const getFileExtension = (filename) => {
        return filename.slice(filename.indexOf('.'))
    }

    const encodeFileToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.onload = () => {
                const base64 = reader.result.split(',')[1]
                resolve({
                    name: file.name,
                    content: base64,
                    type: getFileExtension(file.name),
                    fileObject: file,
                })
            }
            reader.onerror = reject
            reader.readAsDataURL(file)
        })
    }

    const handleFileChange = async (event) => {
        const filesBase64 = await Promise.all(Array.from(event.target.files).map(encodeFileToBase64))

        if (multiple) {
            setFiles(prevFiles => [...prevFiles, ...filesBase64])
        } else {
            setFiles(filesBase64)
        }
    }

    const removeFileElement = (i) => {
        setFiles(prevFiles => prevFiles.filter((_, index) => index !== i))
    }

    const showIcon = (item, i) => {
        if (item.fileObject.type.includes('image/')) {
            return (<img key={i} src={URL.createObjectURL(item.fileObject)} style={{ width: '100%', height: '4rem', objectFit: 'cover', borderRadius: '4px' }}/>)
        }
        if (item.fileObject.type.includes('application/pdf')) {
            return (<img key={i} src={pdf} style={{ width: '40px', paddingTop: 1 }}/>)
        }
        if (item.fileObject.type.includes('text/csv') || item.fileObject.type.includes('xmlformats')) {
            return (<img key={i} src={excel} style={{ width: '40px', paddingTop: 1 }}/>)
        }
        return (<TaskIcon fontSize='inherit' sx={{ fontSize: '55px' }}/>)
    }

    const nameFile = (filename) => filename.slice(0, filename.indexOf('.'))

    const hasFiles = files.length !== 0

    return (
        <Box>
            <Grid2
                container
                direction='column'
                padding={'0.75rem'}
                spacing={1}
                justifyContent={hasFiles ? 'space-between' : 'center'}
                alignItems='center'
                size={12}
                sx={{
                    flex: 1,
                    position: 'relative',
                    cursor: 'pointer',
                    height: '100%',
                    backgroundColor: 'blueStatus.main',
                    border: 'dashed 2px',
                    borderColor: 'primary.main',
                    borderRadius: LARGE_RADIUS,
                }}
            >
                <Grid2 container justifyContent='center' alignItems={'center'} sx={{ flex: 1 }}>
                    <Grid2 container size={12} justifyContent='center' direction='column' alignItems='center'>
                        <NoteAddOutlined sx={{ fontSize: 80, color: 'primary.main' }} />
                        <Grid2 sx={{ color: 'primary.main', fontSize: 'medium' }} >{multiple ? i18n.importMultipleFile : i18n.importSimpleFile }</Grid2>
                        <Grid2 sx={{ color: 'grey', fontSize: 'small', textAlign: 'center' }}>{template(i18n.typeFile)({ fileAccept })}</Grid2>
                    </Grid2>
                </Grid2>
                { hasFiles && (
                    <Grid2 size={12}>
                        <Card>
                            <CardContent sx={{ backgroundColor: 'white' }}>
                                <Grid2 container spacing={2} sx={{ flexWrap: 'nowrap', overflowX: 'scroll', display: 'flex', paddingBottom: 1 }} >
                                    {
                                        files.map((item, i) => (
                                            <Badge key={i} badgeContent={
                                                <Grid2 container justifyContent='center' alignItems='center' sx={{ padding: 0.3, backgroundColor: '#00000060', color: 'white', borderRadius: 5, marginTop: 4, marginRight: 4 }}>
                                                    <Close onClick={() => removeFileElement(i)} sx={{ cursor: 'pointer' }} />
                                                </Grid2>}
                                            >
                                                <Grid2 sx={{ minWidth: 110, maxWidth: 110, backgroundColor: 'blueStatus.main', padding: 1 }} container direction='column' spacing={1} justifyContent='center' alignItems='center'>
                                                    {
                                                        showIcon(item, i)
                                                    }
                                                    <Grid2 sx={{ textAlign: 'center', fontSize: 10 }}>
                                                        { nameFile(item.name).length > 12 ? `${item.name.slice(0, 12)}...${getFileExtension(item.name)}` : item.name}
                                                    </Grid2>
                                                </Grid2>
                                            </Badge>
                                        ))}
                                </Grid2>
                            </CardContent>
                        </Card>
                    </Grid2>
                )}
                <input
                    accept={fileAccept}
                    id='uploadFile'
                    type='file'
                    multiple={multiple}
                    onChange={handleFileChange}
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: hasFiles ? '60%' : '100%',
                        opacity: 0,
                        cursor: 'pointer',
                        margin: 0,
                        padding: 0,
                        fontSize: 20,
                    }}
                />
            </Grid2>
        </Box>
    )
}

FileSelection.propTypes = {
    files: PropTypes.arrayOf(
        PropTypes.shape({
            content: PropTypes.string,
            name: PropTypes.string,
            type: PropTypes.string,
            file: PropTypes.element,
        }),
    ),
    setFiles: PropTypes.func.isRequired,
    multiple: PropTypes.bool,
    fileAccept: PropTypes.string,
}

export default FileSelection